import React from "react";

const COLORS = {
  green: { dot: "bg-emerald-500", bg: "bg-emerald-50", border: "border-emerald-200", text: "text-emerald-900", label: "text-emerald-700" },
  yellow: { dot: "bg-amber-500", bg: "bg-amber-50", border: "border-amber-200", text: "text-amber-900", label: "text-amber-700" },
  red: { dot: "bg-red-500", bg: "bg-red-50", border: "border-red-200", text: "text-red-900", label: "text-red-700" },
  gray: { dot: "bg-stone-300", bg: "bg-stone-50", border: "border-stone-200", text: "text-stone-700", label: "text-stone-500" },
};

export function QualityDot({ status }) {
  const c = COLORS[status] || COLORS.gray;
  return <span className={`inline-block w-2.5 h-2.5 rounded-full ${c.dot}`} />;
}

export function QualityCard({ label, info }) {
  if (!info) return null;
  const c = COLORS[info.status] || COLORS.gray;
  return (
    <div className={`rounded-md border ${c.border} ${c.bg} px-3 py-2`} data-testid={`quality-${label.toLowerCase()}`}>
      <div className="flex items-center justify-between">
        <div className="text-[10px] uppercase tracking-wider font-outfit font-semibold text-stone-600">{label}</div>
        <QualityDot status={info.status} />
      </div>
      <div className={`text-base font-outfit font-semibold ${c.text} tabular-nums mt-0.5`}>{info.value}</div>
      <div className={`text-[11px] ${c.label}`}>{info.label}</div>
    </div>
  );
}

export function QualityOverallBanner({ overall, similar_count }) {
  if (!overall) return null;
  const c = COLORS[overall.status] || COLORS.gray;
  return (
    <div className={`rounded-md border ${c.border} ${c.bg} px-4 py-3 flex items-center justify-between`} data-testid="quality-overall">
      <div className="flex items-center gap-3">
        <QualityDot status={overall.status} />
        <div>
          <div className="text-[10px] uppercase tracking-wider font-outfit font-semibold text-stone-600">Calidad general</div>
          <div className={`text-sm font-medium ${c.text}`}>{overall.label}</div>
        </div>
      </div>
      {typeof similar_count === "number" && (
        <div className="text-right">
          <div className="text-[10px] uppercase tracking-wider font-outfit font-semibold text-stone-500">Lotes similares</div>
          <div className="text-lg font-outfit font-semibold text-stone-900 tabular-nums">{similar_count}</div>
        </div>
      )}
    </div>
  );
}
